import { primitive } from 'styles/constants/primitives';

import {
  Svg,
  SvgDefs,
  SvgG,
  SvgPath,
  SvgProps,
  SvgRect,
  registerSVG,
} from '../../../components/svg';

export function CashApp(props: SvgProps) {
  return (
    <Svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <SvgRect y="5.33334" width="32" height="21.3333" rx="2" fill={primitive.$white} />
      <SvgRect
        x="0.5"
        y="5.83334"
        width="31"
        height="20.3333"
        rx="1.5"
        stroke="black"
        stroke-opacity="0.3"
      />
      <SvgG clip-path="url(#clip0_13102_93)">
        <SvgPath
          d="M23.2991 9.33334H8.93479C7.68218 9.33334 6.66675 10.3488 6.66675 11.6014V20.3986C6.66675 21.6512 7.68218 22.6667 8.93479 22.6667H23.2991C24.5517 22.6667 25.5671 21.6512 25.5671 20.3986V11.6014C25.5671 10.3488 24.5517 9.33334 23.2991 9.33334Z"
          fill="#00D64F"
        />
        <SvgPath
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.3956 13.8359C17.0277 13.8359 17.6336 14.0918 18.0296 14.4432C18.1296 14.5321 18.2795 14.5316 18.3736 14.4364L18.8446 13.9586C18.944 13.8578 18.9404 13.6927 18.833 13.6005C18.5169 13.3288 18.0925 13.0616 17.5703 12.8905L17.718 12.187C17.7501 12.0336 17.6333 11.8895 17.4765 11.8895H16.5663C16.4499 11.8895 16.3492 11.971 16.3249 12.0849L16.1918 12.7105C14.9818 12.771 13.9562 13.3748 13.9562 14.6136C13.9562 15.686 14.8048 16.1457 15.7004 16.4638C16.5489 16.7819 16.9966 16.8999 16.9966 17.3476C16.9966 17.8073 16.5489 18.0783 15.8888 18.0783C15.287 18.0783 14.6567 17.8797 14.1675 17.3974C14.0716 17.3027 13.918 17.302 13.8221 17.3966L13.3159 17.8959C13.2169 17.9935 13.2178 18.154 13.3175 18.2506C13.7122 18.6337 14.2118 18.9111 14.7822 19.0664L14.6433 19.7181C14.6109 19.8709 14.7266 20.015 14.883 20.0163L15.7947 20.0232C15.912 20.0241 16.0139 19.9421 16.0378 19.8271L16.1694 19.2005C17.6182 19.1111 18.505 18.3236 18.505 17.1709C18.505 16.1104 17.6213 15.6625 16.5489 15.2972C15.936 15.0731 15.4056 14.9201 15.4056 14.4606C15.4056 14.0129 15.9008 13.8359 16.3956 13.8359Z"
          fill="white"
        />
      </SvgG>
      <SvgDefs>
        <clipPath id="clip0_13102_93">
          <SvgRect
            width="18.9003"
            height="13.3333"
            fill="white"
            transform="translate(6.66675 9.33334)"
          />
        </clipPath>
      </SvgDefs>
    </Svg>
  );
}
registerSVG('CashApp', CashApp);
